var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade-in-up"}},[_c('router-view',[_vm._v("shiftWorkConfig page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }